import script from "./ContentReviewer.vue?vue&type=script&lang=ts&setup=true"
export * from "./ContentReviewer.vue?vue&type=script&lang=ts&setup=true"

import "./ContentReviewer.vue?vue&type=style&index=0&id=30b322c5&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30b322c5"]])

export default __exports__